"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Map_ios_exports = {};
__export(Map_ios_exports, {
  Map: () => Map
});
module.exports = __toCommonJS(Map_ios_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_OneNativeUiMapNativeComponent = __toESM(require("../specs/OneNativeUiMapNativeComponent"), 1);
var import_mapValidation = require("./mapValidation");
function Map(param) {
  var { cameraPosition, markers, polylines, polygons, circles, onCameraMove, onMarkerClick, onMapClick, style, testID, accessibilityLabel } = param;
  var model = (0, import_mapValidation.resolveNativeMapModel)({
    cameraPosition,
    markers,
    polylines,
    polygons,
    circles
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_OneNativeUiMapNativeComponent.default, {
    style,
    testID,
    accessibilityLabel,
    latitude: model.latitude,
    longitude: model.longitude,
    zoom: model.zoom,
    markers: model.markers,
    overlays: model.overlays,
    onNativeUiMapCameraMove: function onNativeUiMapCameraMove(param2) {
      var { nativeEvent } = param2;
      return onCameraMove === null || onCameraMove === void 0 ? void 0 : onCameraMove({
        coordinates: {
          latitude: nativeEvent.latitude,
          longitude: nativeEvent.longitude
        },
        zoom: nativeEvent.zoom
      });
    },
    onNativeUiMapMarkerClick: function onNativeUiMapMarkerClick(param2) {
      var { nativeEvent } = param2;
      var marker = (markers !== null && markers !== void 0 ? markers : []).find(function(item) {
        return item.id === nativeEvent.id;
      });
      if (marker) onMarkerClick === null || onMarkerClick === void 0 ? void 0 : onMarkerClick(marker);
    },
    onNativeUiMapClick: function onNativeUiMapClick(param2) {
      var { nativeEvent } = param2;
      return onMapClick === null || onMapClick === void 0 ? void 0 : onMapClick({
        coordinates: {
          latitude: nativeEvent.latitude,
          longitude: nativeEvent.longitude
        }
      });
    }
  });
}
//# sourceMappingURL=Map.ios.js.map
